import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useApp } from "../context/AppContext";
import { Button } from "./ui/button";

export const InquiryAccessLink = () => {
  const { user } = useApp();
  const allowed = ["employee", "admin"].includes(user?.role);
  return allowed ? <Button asChild variant="outline" className="mt-4 gap-2"><Link data-testid="staff-inquiries-link" to="/staff/inquiries"><MessageCircle className="w-4 h-4 text-orange-600" />Inquiries</Link></Button> : null;
};